<template>
    <div class="success-page">
        <div class="content">
            <h1>
                <i class="fa-regular fa-circle-check text-white"></i>
            </h1>
            <h3 class="fw-bold">Registrazione completata!</h3>
            <p>Ti è stata inviata una e-mail per verificare il tuo account.</p>
            <button @click="openDeepLink" class="btn btn-custom">Torna all'App</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuccessPage",
    methods: {
        openDeepLink() {
            const deeplink = "elitefitness://elitefitness.it";
            const iosStore = "https://apps.apple.com/it/app/id6670614281";
            const androidStore = "https://play.google.com/store/apps/details?id=it.utopialabs.elitefitness";
            const fallbackWeb = "https://elitefitness.it"; // opzionale

            const ua = navigator.userAgent || navigator.vendor || window.opera;
            let storeUrl;

            if (/android/i.test(ua)) {
                storeUrl = androidStore;
            } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                storeUrl = iosStore;
            } else {
                // Desktop o altro → vai al sito (puoi cambiarlo in uno store generico)
                window.location = fallbackWeb;
                return;
            }

            const now = Date.now();
            window.location = deeplink;

            setTimeout(() => {
                if (Date.now() - now < 1600) {
                    window.location = storeUrl;
                }
            }, 1500);
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

.success-page {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    /* Full page height */
    background-color: #292D7D;
    /* Background blu */
}

.content {
    text-align: center;
    color: white;
    font-family: 'Montserrat', sans-serif;
}

h1 {
    font-size: 3rem;
    font-weight: 600;
}

p {
    font-size: 1.5rem;
    margin-top: 20px;
    margin-bottom: 40px;
}

.success-image {
    width: 150px;
    height: 150px;
    margin-bottom: 30px;
}

/* Stile del pulsante */
.btn-custom {
    font-family: 'Montserrat', sans-serif;
    background-color: #e83539;
    color: white;
    border: none;
    padding: 10px 20px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 0;
    font-size: 1.2rem;
}

.btn-custom:hover {
    background-color: #cc2e31;
    color: white;
}
</style>